// File: /src/pages/FinanceDashboard.js

import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import FinanceDashCards from '../components/finance/FinanceDashCards';
import FinanceDashCharts from '../components/finance/FinanceDashCharts';
import FinanceDashTable from '../components/finance/FinanceDashTable';
import FinanceDashForm from '../components/finance/FinanceDashForm';
import AdvancedReportFilters from '../components/finance/AdvancedReportFilters';

import '../styles/finance/FinanceDashboard.css';
import '../styles/ModalStyle.css';
import '../styles/CustomToastify.css';

import { useFinanceData } from '../hooks/useFinanceData';
import { useFinanceSummary } from '../hooks/finance/useFinanceSummary';
import { useFinanceEntries } from '../hooks/finance/useFinanceEntries';
import { useConfirmDialog } from '../hooks/useConfirmDialog';

function FinanceDashboard() {
	const {
		financeSummary,
		setFinanceSummary,
		manualEntries,
		setManualEntries,
		paidInvoices,
		allInvoices,
		projects,
		clients,
		loading,
		error,
		refreshFinanceData,
	} = useFinanceData();

	const { showConfirm } = useConfirmDialog();
	const { summary, pieData, kpis } = useFinanceSummary(financeSummary);

	const {
		tableEntries,
		lineData,
		period,
		setPeriod,
		showModal,
		openModalForCreation,
		startEditingEntry,
		closeModal,
		handleInputChange,
		addOrUpdateFinanceEntry,
		deleteEntry,
		form,
		editingEntry,
	} = useFinanceEntries({
		manualEntries,
		paidInvoices,
		allInvoices,
		setManualEntries,
		setFinanceSummary,
		refreshFinanceData,
		showConfirm,
	});

	useEffect(() => {
		if (error) {
			toast.error('Falha ao carregar dados financeiros.');
		}
	}, [error]);

	return (
		<div className="finance-dashboard">
			<h1>Gerenciamento Financeiro</h1>
			{loading ? (
				<p className="loading-text">
					Carregando...
					<br />
					<span className="loading-spinner"></span>
				</p>
			) : (
				<>
					<FinanceDashCards financeSummary={summary} kpis={kpis} />

					<FinanceDashCharts
						pieData={pieData}
						lineData={lineData}
						period={period}
						setPeriod={setPeriod}
					/>

					<FinanceDashTable
						allEntries={tableEntries}
						openModalForCreation={openModalForCreation}
						startEditingEntry={startEditingEntry}
						deleteEntry={deleteEntry}
					/>

					{showModal && (
						<div
							className="modal-overlay"
							onClick={(event) => {
								if (
									event.target.classList.contains(
										'modal-overlay',
									)
								) {
									closeModal();
								}
							}}
						>
							<div className="modal-content">
								<IconButton
									type="button"
									className="modal-close-btn"
									onClick={closeModal}
								>
									<CloseIcon />
								</IconButton>
								<FinanceDashForm
									form={form}
									handleInputChange={handleInputChange}
									addOrUpdateFinanceEntry={
										addOrUpdateFinanceEntry
									}
									closeModal={closeModal}
									editingEntry={editingEntry}
								/>
							</div>
						</div>
					)}

					<section className="reports-center">
						<h2>Relatórios Financeiros</h2>
						<div className="reports-center-content">
							<AdvancedReportFilters
								entries={tableEntries}
								financeSummary={summary}
								paidInvoices={paidInvoices}
								lineData={lineData}
								period={period}
								projects={projects}
								clients={clients}
							/>
						</div>
					</section>
				</>
			)}
		</div>
	);
}

export default FinanceDashboard;
